export const worksTv = [
  {
    id: "t-01",
    title: "长风渡月",
    type: "tv" as const,
    year: 2024,
    region: "中国大陆",
    language: "国语",
    genres: ["古装", "权谋", "爱情"],
    director: "温言之",
    actors: ["江离", "穆舟", "谢闻"],
    duration: "全40集",
    rating: 8.8,
    summary:
      "没落世家女江离与寒门谋士穆舟携手入局，在波谲云诡的朝堂中彼此成全，从棋局之子一步步走到执棋之人。",
    poster:
      "https://readdy.ai/api/search-image?query=an%20elegant%20Chinese%20noblewoman%20in%20ornate%20hanfu%20standing%20beside%20a%20young%20strategist%20in%20palace%20corridors%20at%20dusk%2C%20refined%20warm%20gold%20and%20deep%20red%20tones%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-t01-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20majestic%20ancient%20Chinese%20palace%20courtyard%20at%20dusk%2C%20lanterns%20glowing%2C%20mist%20and%20autumn%20leaves%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-t01-backdrop&orientation=landscape",
    tags: ["权谋", "双向奔赴", "群像"],
    hot: true,
    updatedAt: "2024-08-01",
  },
  {
    id: "t-02",
    title: "都市夜归人",
    type: "tv" as const,
    year: 2023,
    region: "中国大陆",
    language: "国语",
    genres: ["都市", "情感", "治愈"],
    director: "周慕",
    actors: ["何以安", "苏晚"],
    duration: "全36集",
    rating: 8.3,
    summary:
      "深夜便利店里，一群不愿回家的人交换着各自的故事，孤独与温暖在城市的缝隙里悄然相遇。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20lone%20woman%20standing%20inside%20a%20glowing%20convenience%20store%20at%20midnight%2C%20neon%20reflections%20on%20wet%20pavement%20outside%2C%20moody%20urban%20atmosphere%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-t02-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20rainy%20city%20street%20at%20night%20with%20glowing%20convenience%20store%20windows%2C%20wet%20reflections%20and%20light%20trails%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-t02-backdrop&orientation=landscape",
    tags: ["都市", "群像", "治愈"],
    hot: false,
    updatedAt: "2024-05-14",
  },
  {
    id: "t-03",
    title: "刑侦档案",
    type: "tv" as const,
    year: 2024,
    region: "中国大陆",
    language: "国语",
    genres: ["悬疑", "犯罪", "刑侦"],
    director: "韩征",
    actors: ["顾岩", "白露"],
    duration: "全32集",
    rating: 8.5,
    summary:
      "重案组组长顾岩凭借对细节的偏执，从一桩沉寂多年的悬案顺藤摸瓜，牵出一张横跨多年的犯罪网络。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20stern%20detective%20in%20a%20trench%20coat%20examining%20a%20case%20file%20board%20under%20cold%20light%2C%20dark%20investigation%20room%2C%20tense%20blue%20gray%20tones%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-t03-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20dim%20police%20investigation%20room%20with%20evidence%20boards%20and%20scattered%20files%2C%20cold%20moody%20lighting%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-t03-backdrop&orientation=landscape",
    tags: ["刑侦", "单元剧", "烧脑"],
    hot: true,
    updatedAt: "2024-08-12",
  },
  {
    id: "t-04",
    title: "宇宙边疆",
    type: "tv" as const,
    year: 2024,
    region: "美国",
    language: "英语",
    genres: ["科幻", "太空", "冒险"],
    director: "Eric Nolan",
    actors: ["Zoe Adler", "Mark Reyes", "Iris Chan"],
    duration: "全24集",
    rating: 9.0,
    summary:
      "人类边境殖民星陷入资源危机，一支舰队踏上未知深空，寻找传说中能让文明得以延续的第二家园。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20diverse%20crew%20in%20sleek%20futuristic%20space%20suits%20standing%20on%20a%20starship%20bridge%2C%20holographic%20star%20map%20glowing%2C%20epic%20sci-fi%20lighting%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-t04-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20colossal%20starship%20fleet%20flying%20toward%20a%20vast%20unknown%20star%20region%2C%20deep%20space%2C%20epic%20scale%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-t04-backdrop&orientation=landscape",
    tags: ["硬科幻", "太空歌剧", "史诗"],
    hot: true,
    updatedAt: "2024-09-03",
  },
  {
    id: "t-05",
    title: "医者仁心",
    type: "tv" as const,
    year: 2022,
    region: "中国大陆",
    language: "国语",
    genres: ["医疗", "职场", "都市"],
    director: "徐澜",
    actors: ["唐宁", "季然"],
    duration: "全42集",
    rating: 8.2,
    summary:
      "急诊科医生唐宁在高强度的工作与生死抉择中坚守初心，与同事们一起守护每一位患者的希望。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20focused%20young%20doctor%20in%20a%20white%20coat%20standing%20in%20a%20bright%20modern%20hospital%20corridor%2C%20warm%20hopeful%20light%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-t05-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20modern%20hospital%20emergency%20department%20with%20busy%20medical%20staff%2C%20clean%20bright%20atmosphere%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-t05-backdrop&orientation=landscape",
    tags: ["医疗", "职场", "温情"],
    hot: false,
    updatedAt: "2024-01-19",
  },
  {
    id: "t-06",
    title: "东京恋物语",
    type: "tv" as const,
    year: 2023,
    region: "日本",
    language: "日语",
    genres: ["爱情", "都市", "治愈"],
    director: "山田凉",
    actors: ["佐藤樱", "小林彻"],
    duration: "全12集",
    rating: 8.4,
    summary:
      "同一座城市里，习惯错过的两个人因一本旧书结缘，在四季流转中慢慢学会靠近与告别。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20young%20man%20and%20woman%20standing%20on%20a%20Tokyo%20crosswalk%20in%20spring%20cherry%20blossom%20light%2C%20gentle%20romantic%20mood%2C%20soft%20pastel%20tones%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-t06-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20quiet%20Tokyo%20street%20around%20dusk%20with%20cherry%20blossoms%20and%20warm%20shop%20window%20lights%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-t06-backdrop&orientation=landscape",
    tags: ["纯爱", "都市", "治愈"],
    hot: false,
    updatedAt: "2024-04-22",
  },
  {
    id: "t-07",
    title: "迷雾之岛",
    type: "tv" as const,
    year: 2023,
    region: "英国",
    language: "英语",
    genres: ["悬疑", "惊悚", "剧情"],
    director: "James Holt",
    actors: ["Clara Doyle", "Neil Frost"],
    duration: "全8集",
    rating: 8.6,
    summary:
      "一座与世隔绝的小岛上，居民们遵循着古老而诡异的规矩，新来的警长发现所有人都藏着不可告人的秘密。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20lone%20sheriff%20standing%20on%20a%20foggy%20windswept%20island%20cliff%2C%20a%20distant%20lighthouse%20beam%2C%20eerie%20gray%20blue%20atmosphere%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-t07-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20mysterious%20fog%20covered%20island%20with%20a%20lonely%20lighthouse%20at%20dusk%2C%20moody%20gray%20tones%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-t07-backdrop&orientation=landscape",
    tags: ["悬疑", "孤岛", "烧脑"],
    hot: false,
    updatedAt: "2024-03-27",
  },
  {
    id: "t-08",
    title: "少年书院",
    type: "tv" as const,
    year: 2024,
    region: "中国大陆",
    language: "国语",
    genres: ["青春", "成长", "古装"],
    director: "沈砚",
    actors: ["林知夏", "程野"],
    duration: "全30集",
    rating: 8.0,
    summary:
      "山间书院里的少年们怀揣各自的梦想，在老师的引领下直面成长烦恼，走向更广阔的天地。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20group%20of%20cheerful%20Chinese%20students%20in%20simple%20hanfu%20running%20across%20a%20mountain%20academy%20courtyard%2C%20soft%20morning%20light%2C%20youthful%20energy%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-t08-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20serene%20ancient%20Chinese%20mountain%20academy%20surrounded%20by%20misty%20peaks%2C%20warm%20morning%20light%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-t08-backdrop&orientation=landscape",
    tags: ["青春", "校园", "励志"],
    hot: false,
    updatedAt: "2024-06-28",
  },
];